var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Input as CoreInput } from 'wix-ui-core/dist/es/src/components/input';
import { st, classes } from './Input.st.css';
import { ErrorMessageWrapper } from '../ErrorMessageWrapper';
export var Input = function (props) {
    var errorMessage = props.errorMessage, error = props.error, className = props.className, coreInputProps = __rest(props, ["errorMessage", "error", "className"]);
    var disabled = props.disabled;
    return (React.createElement(ErrorMessageWrapper, { error: error, errorMessage: errorMessage, disabled: disabled, render: function (errorProps) { return (React.createElement(CoreInput, __assign({ className: st(classes.root, { error: error }, className), error: errorProps.error }, coreInputProps))); } }));
};
//# sourceMappingURL=Input.js.map